package one.healthium.domain.user.models

data class PrognoseWeightModel(
    val weight: Float,
    val inDays: Int,
)
